/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Details_Archive_Reason_TransferInputs */

const fr_vehicle_details_archive_reason_transfer = /** @type {(inputs: Vehicle_Details_Archive_Reason_TransferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a été transféré`)
};

const en_vehicle_details_archive_reason_transfer = /** @type {(inputs: Vehicle_Details_Archive_Reason_TransferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`was transferred`)
};

/**
* | output |
* | --- |
* | "was transferred" |
*
* @param {Vehicle_Details_Archive_Reason_TransferInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_details_archive_reason_transfer = /** @type {((inputs?: Vehicle_Details_Archive_Reason_TransferInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Details_Archive_Reason_TransferInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_details_archive_reason_transfer(inputs)
	return en_vehicle_details_archive_reason_transfer(inputs)
});